// public/js/modules/filters/clustering-filter.js
export const clusteringFilter = {
    id: 'clustering',
    getDefaultState: () => ({ enabled: true }),
  
    // Clustering is toggled via a map control button now (see pages/map.js),
    // so it no longer renders in the sidebar filter list. The filter stays
    // registered to keep its enabled-state in the FilterManager.
    renderUI() {
      return '';
    },
  
    apply(assets, state) {
      return assets; // the real logic now lives in renderFilteredMarkers
    },
  
    attachListeners(container, manager) {
      const toggle = container.querySelector('#cluster-toggle');
      if (toggle) {
        toggle.addEventListener('change', () => {
          manager.updateFilter('clustering', { enabled: toggle.checked });
        });
      }
    }
  };